"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCalendarState = exports.calendarReducer = exports.SET_CALENDAR_ERRORS = exports.CHANGE_CALENDAR_DATE = exports.REMOVE_CALENDAR_SLOT = exports.ADD_CALENDAR_SLOT = exports.TOGGLE_CALENDAR_DAY = exports.getEmptySlot = exports.findIndexById = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _ramda = require("ramda");

var _react = require("react");

var _personalProfileSettings = require("../../store/personalProfileSettings/personalProfileSettings.contants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var findIndexById = function findIndexById(id, items) {
  var index = (0, _ramda.findIndex)((0, _ramda.propEq)('id', id), items);
  return [index, items[index]];
};

exports.findIndexById = findIndexById;

var randomId = function randomId() {
  return "_".concat(Math.random().toString(36).substr(2, 9));
};

var getEmptySlot = function getEmptySlot(day) {
  return {
    id: randomId(),
    day,
    from: (0, _ramda.clone)(_personalProfileSettings.DEFAULT_START_OF_THE_DAY),
    till: (0, _ramda.clone)(_personalProfileSettings.DEFAULT_END_OF_THE_DAY)
  };
};

exports.getEmptySlot = getEmptySlot;
var TOGGLE_CALENDAR_DAY = 'TOGGLE_CALENDAR_DAY';
exports.TOGGLE_CALENDAR_DAY = TOGGLE_CALENDAR_DAY;
var ADD_CALENDAR_SLOT = 'ADD_CALENDAR_SLOT';
exports.ADD_CALENDAR_SLOT = ADD_CALENDAR_SLOT;
var REMOVE_CALENDAR_SLOT = 'REMOVE_CALENDAR_SLOT';
exports.REMOVE_CALENDAR_SLOT = REMOVE_CALENDAR_SLOT;
var CHANGE_CALENDAR_DATE = 'CHANGE_CALENDAR_DATE';
exports.CHANGE_CALENDAR_DATE = CHANGE_CALENDAR_DATE;
var SET_CALENDAR_ERRORS = 'SET_CALENDAR_ERRORS';
exports.SET_CALENDAR_ERRORS = SET_CALENDAR_ERRORS;
var hasErrorsInDaysSlots = (0, _ramda.pipe)((0, _ramda.pluck)('slots'), _ramda.flatten, (0, _ramda.reject)(function (slot) {
  return !slot.tillError && !slot.fromError;
}), (0, _ramda.complement)((0, _ramda.propEq)('length', 0)));
var MIN_FREQUENCY = 15;

var addSlot = function addSlot(id, state) {
  var _findIndexById = findIndexById(id, state.days),
      _findIndexById2 = (0, _slicedToArray2.default)(_findIndexById, 2),
      index = _findIndexById2[0],
      day = _findIndexById2[1];

  return _objectSpread(_objectSpread({}, state), {}, {
    hasErrors: hasErrorsInDaysSlots(state.days),
    days: (0, _ramda.update)(index, _objectSpread(_objectSpread({}, day), {}, {
      slots: (0, _ramda.append)(getEmptySlot(day.id), day.slots)
    }), state.days)
  });
};

var removeSlot = function removeSlot(_ref, state) {
  var id = _ref.id,
      dayId = _ref.day;

  var _findIndexById3 = findIndexById(dayId, state.days),
      _findIndexById4 = (0, _slicedToArray2.default)(_findIndexById3, 2),
      index = _findIndexById4[0],
      day = _findIndexById4[1];

  var days = (0, _ramda.update)(index, _objectSpread(_objectSpread({}, day), {}, {
    slots: (0, _ramda.reject)((0, _ramda.propEq)('id', id), day.slots)
  }), state.days);
  return _objectSpread(_objectSpread({}, state), {}, {
    hasErrors: hasErrorsInDaysSlots(days),
    days
  });
};

var toggleDay = function toggleDay(_ref2, state) {
  var id = _ref2.id,
      enabled = _ref2.enabled;

  var _findIndexById5 = findIndexById(id, state.days),
      _findIndexById6 = (0, _slicedToArray2.default)(_findIndexById5, 2),
      index = _findIndexById6[0],
      day = _findIndexById6[1];

  var days = (0, _ramda.update)(index, _objectSpread(_objectSpread({}, day), {}, {
    enabled,
    slots: [_objectSpread({}, getEmptySlot(day.id))]
  }), state.days);
  return _objectSpread(_objectSpread({}, state), {}, {
    hasErrors: hasErrorsInDaysSlots(days),
    days
  });
};

var changeDate = function changeDate(_ref3, state) {
  var id = _ref3.id,
      dayId = _ref3.day,
      type = _ref3.type,
      value = _ref3.value;

  var _findIndexById7 = findIndexById(dayId, state.days),
      _findIndexById8 = (0, _slicedToArray2.default)(_findIndexById7, 2),
      index = _findIndexById8[0],
      day = _findIndexById8[1];

  var _findIndexById9 = findIndexById(id, day.slots),
      _findIndexById10 = (0, _slicedToArray2.default)(_findIndexById9, 2),
      slotIndex = _findIndexById10[0],
      slot = _findIndexById10[1];

  var hasErrors = !value || !value.isValid();
  var errorProp = "".concat(type, "Error");
  var errorMessage = '';

  if (!value) {
    errorMessage = 'Field is required';
  }

  if (value && !value.isValid()) {
    errorMessage = 'Invalid time format';
  }

  var updateSlot = _objectSpread(_objectSpread({}, slot), {}, {
    [type]: value,
    [errorProp]: errorMessage
  });

  var otherType = type === 'from' ? 'till' : 'from';
  var otherValue = slot[otherType];
  var otherHasErrors = !otherValue || !otherValue.isValid();

  if (!hasErrors && !otherHasErrors) {
    // Find conditions to redefine slot's times
    var isWrongDayPeriod = type === 'from' && value.isAfter(otherValue) || type === 'till' && value.isBefore(otherValue);
    var isWrongFrequency = Math.abs(value.diff(otherValue, 'minutes')) < MIN_FREQUENCY;
    var needToRedefineSlotTimes = isWrongFrequency || isWrongDayPeriod;

    if (needToRedefineSlotTimes) {
      var mutateFunc = type === 'from' ? 'add' : 'subtract';
      otherValue = value.clone()[mutateFunc](MIN_FREQUENCY, 'minutes'); // Edge day case

      if (otherValue.date() !== value.date()) {
        updateSlot[type] = value.set({
          hour: 0,
          minute: MIN_FREQUENCY
        });
        otherValue = value.clone().set({
          hour: 0,
          minute: 0
        });
      }

      updateSlot[otherType] = otherValue;
    }
  }

  return _objectSpread(_objectSpread({}, state), {}, {
    hasErrors,
    days: (0, _ramda.update)(index, _objectSpread(_objectSpread({}, day), {}, {
      slots: (0, _ramda.update)(slotIndex, updateSlot, day.slots)
    }), state.days)
  });
};

var setErrors = function setErrors(payload, state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    errors: payload
  });
};

var calendarReducer = function calendarReducer(state, _ref4) {
  var type = _ref4.type,
      payload = _ref4.payload;

  switch (type) {
    case ADD_CALENDAR_SLOT:
      return addSlot(payload, state);

    case REMOVE_CALENDAR_SLOT:
      return removeSlot(payload, state);

    case TOGGLE_CALENDAR_DAY:
      return toggleDay(payload, state);

    case CHANGE_CALENDAR_DATE:
      return changeDate(payload, state);

    case SET_CALENDAR_ERRORS:
      return setErrors(payload, state);

    default:
      return state;
  }
};

exports.calendarReducer = calendarReducer;

var useCalendarState = function useCalendarState(initialState) {
  var _useReducer = (0, _react.useReducer)(calendarReducer, initialState),
      _useReducer2 = (0, _slicedToArray2.default)(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  return [state, {
    addSlotAction: (0, _react.useCallback)(function (payload) {
      return dispatch({
        type: ADD_CALENDAR_SLOT,
        payload
      });
    }, []),
    removeSlotAction: (0, _react.useCallback)(function (payload) {
      return dispatch({
        type: REMOVE_CALENDAR_SLOT,
        payload
      });
    }, []),
    toggleDayAction: (0, _react.useCallback)(function (payload) {
      return dispatch({
        type: TOGGLE_CALENDAR_DAY,
        payload
      });
    }, []),
    changeDateAction: (0, _react.useCallback)(function (payload) {
      return dispatch({
        type: CHANGE_CALENDAR_DATE,
        payload
      });
    }, []),
    setErrorsAction: (0, _react.useCallback)(function (payload) {
      return dispatch({
        type: SET_CALENDAR_ERRORS,
        payload
      });
    }, [])
  }];
};

exports.useCalendarState = useCalendarState;